import Login from "./AuthPages/Login/Index";
import ForgotPassword from "./AuthPages/forgotPassword/Index";
import AgencyDetail from "./SideTabPages/ManageAgency/AgencyDetail";
import CustomerDetail from "./SideTabPages/CustomerDetail";
import Dashboard from "./SideTabPages/Dashboard";
import NewAgencyRequest from "./SideTabPages/ManageAgency/NewAgencyRequest";
import RegisteredAgency from "./SideTabPages/ManageAgency/RegesteredAgency";
import ManageCustomers from "./SideTabPages/ManageCustomer";
import NewDriverRequest from "./SideTabPages/ManageDriver/NewDriverRequest";
import RegisteredDriver from "./SideTabPages/ManageDriver/RegisteredDriver";
import Setting from "./SideTabPages/Setting";
import DriverDetail from "./SideTabPages/ManageDriver/DriverDetail";
import DisputeManagement from "./SideTabPages/DisputeManagement";
import DisputeDetail from "./SideTabPages/DisputeManagement/DisputeDetail";
import Service from "./SideTabPages/Service";
import AddService from "./SideTabPages/Service/Add";
import FareRequest from "./SideTabPages/FareRequest";
import FareDetail from "./SideTabPages/FareRequest/FareDetail";
import ManageBooking from "./SideTabPages/ManageBooking";
import DriverBookingDetail from "./SideTabPages/ManageDriver/DriverBookingDetail";
import BookingDetail from "./SideTabPages/ManageBooking/BookingDetail";
import BirdEyeView from "./SideTabPages/BirdEyeView";
import Promotions from "./SideTabPages/Promotions";
import AddPromotion from "./SideTabPages/Promotions/Add";
import Promocodes from "./SideTabPages/Promocodes";
import AddPromoCode from "./SideTabPages/Promocodes/Add";
import Accounting from "./SideTabPages/Accounting";
import SystemAccess from "./SideTabPages/SystemAccess";
import AddSystemAccess from "./SideTabPages/SystemAccess/Add";
import DriverReport from "./SideTabPages/Reports/DriverReport";
import DriverReportView from "./SideTabPages/Reports/DriverReport/reportview";
import BookingReport from "./SideTabPages/Reports/BookingReport";
import FAQs from "./SideTabPages/Configuration/FAQs";
import AddFaq from "./SideTabPages/Configuration/AddFaq";
import ContentPages from "./SideTabPages/Configuration/ContentPages";
import AddContent from "./SideTabPages/Configuration/AddContent";
import EmailTemp from "./SideTabPages/Configuration/EmailTemplate";
import SMSTemp from "./SideTabPages/Configuration/SMSTemplate";
import ServiceDetail from "./SideTabPages/Service/Detail";
import BasicSetting from "./SideTabPages/Configuration/BasicSetting";
import AddAgency from "./SideTabPages/ManageAgency/add";
import AddDriver from "./SideTabPages/ManageDriver/Add";
import AgencyBookingDetail from "./SideTabPages/ManageAgency/BookingDetails";
import AgencyView from "./SideTabPages/ManageAgency/NewAgencyRequest/agencyview";
import NewDriverReqView from "./SideTabPages/ManageDriver/NewDriverRequest/NewDriverReqView";
import PublicPage from "./PublicPages/Page";
import ManageVendor from "./SideTabPages/ManageVendor";
import VendorDetail from "./SideTabPages/ManageVendor/VendorDetail";
import VendorSignupPage from "./AuthPages/Vendor/Signup/Index";
import Vendors from "./SideTabPages/Vendors";
import VendorsDetail from "./SideTabPages/Vendors/Detail";
import Widget from "./PublicPages/Page/Widget";
import WalletPage from "./SideTabPages/Wallet";


export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
];

export const privateRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/setting", component: <Setting /> },
  { path: "/manage-customers", component: <ManageCustomers /> },
  { path: "/manage-customers/view/:id", component: <CustomerDetail /> },
  { path: "/manage-agency/registered-agency", component: <RegisteredAgency /> },
  { path: "/manage-agency/add", component: <AddAgency /> },
  { path: "/manage-agency/edit/:id", component: <AddAgency /> },
  {
    path: "/manage-agency/registered-agency/view/:id",
    component: <AgencyDetail />,
  },
  {
    path: "/manage-agency/agency-request/view/:id",
    component: <AgencyView />,
  },
  { path: "/manage-agency/agency-request", component: <NewAgencyRequest /> },
  { path: "/manage-driver/add", component: <AddDriver /> },
  { path: "/manage-driver/edit/:id", component: <AddDriver /> },
  { path: "/manage-driver/registered-driver", component: <RegisteredDriver /> },
  { path: "/manage-driver/driver-request", component: <NewDriverRequest /> },
  {
    path: "/manage-driver/driver-request/view/:id",
    component: <NewDriverReqView />,
  },
  {
    path: "/manage-driver/registered-driver/view/:id",
    component: <DriverDetail />,
  },
  {
    path: "/manage-driver/booking-detail/:id",
    component: <DriverBookingDetail />,
  },
  { path: "/dispute-management", component: <DisputeManagement /> },
  { path: "/dispute-management/view/:id", component: <DisputeDetail /> },
  { path: "/vehicle", component: <Service /> },
  { path: "/vehicle/add", component: <AddService /> },
  { path: "/vehicle/edit/:id", component: <AddService /> },
  { path: "/vehicle/view/:id", component: <ServiceDetail /> },
  { path: "/fare-request", component: <FareRequest /> },
  { path: "/fare-request/detail/:id", component: <FareDetail /> },
  { path: "/manage-booking", component: <ManageBooking /> },
  { path: "/manage-booking/detail/:id", component: <BookingDetail /> },
  { path: "/guest-booking", component: <ManageVendor /> },
  { path: "/guest-booking/detail/:id", component: <VendorDetail /> },
  { path: "/bird-eye-view", component: <BirdEyeView /> },
  { path: "/promotions", component: <Promotions /> },
  { path: "/promotions/add", component: <AddPromotion /> },
  { path: "/promotions/edit/:id", component: <AddPromotion /> },
  { path: "/promocodes", component: <Promocodes /> },
  { path: "/promocodes/add", component: <AddPromoCode /> },
  { path: "/promocodes/edit/:id", component: <AddPromoCode /> },
  { path: "/transaction-history", component: <Accounting /> },
  { path: "/system-access", component: <SystemAccess /> },
  { path: "/system-access/add", component: <AddSystemAccess /> },
  { path: "/system-access/edit/:id", component: <AddSystemAccess /> },
  // report
  { path: "/reports/driver-report", component: <DriverReport /> },
  { path: "/reports/booking-report", component: <BookingReport /> },
  { path: "/driver-report/detail/:id", component: <DriverReportView /> },
  // faq
  { path: "/configuration/faq", component: <FAQs /> },
  { path: "/configuration/faq/add", component: <AddFaq /> },
  { path: "/configuration/faq/edit/:id", component: <AddFaq /> },
  //content
  { path: "/configuration/content-pages", component: <ContentPages /> },
  // { path: "/configuration/content-pages/add", component: <AddContent /> },
  { path: "/configuration/content-pages/edit/:id", component: <AddContent /> },

  { path: "/configuration/email-template", component: <EmailTemp /> },
  { path: "/configuration/sms-template", component: <SMSTemp /> },
  { path: "/configuration/basic-setting", component: <BasicSetting /> },
  { path: "/agency-booking/detail/:id", component: <AgencyBookingDetail /> },
  { path: "/vendors", component: <Vendors /> },
  { path: "/vendors/view/:id", component: <VendorsDetail /> },
  { path: "/new-booking", component: <PublicPage /> },
  { path: "/wallet", component: <WalletPage /> },
  { path: "/chat", component: <Accounting /> },
];

// Route for delvit public link html.
export const publicRoutes = [
  { path: "/signup", component: <VendorSignupPage /> },
  { path: "/widget/get-it-by-delivit/:vendorId", component: <Widget /> },

];
